// 应用初始的message提醒
import { AppMessage, AppModal, AppModalSimple } from "Types/app"

export const InitialAppMessage: AppMessage = {
    show: false,
    type: "info",
    text: "",
}
export const InitialAppModal: AppModal = {
    show: false,
    type: "default",
    title: "",
    onConfirm: () => {},
    onCancel: () => {},
}
export const InitialAppModalSimple: AppModalSimple = {
    show: false,
    title: "",
}

// 用户信息初始值
export const InitialUser= {
    uid: "",
    token: "",
}
